import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { List } from 'immutable';
import {
    fetchChannelCalendar,
    updateChannelOpeningHours,
} from 'flow/actions/channels-actions';
import CalendarBase from 'flow/components/calendar/CalendarBase';
import Loading from 'flow/components/ui-components/Loading';
import { ChannelKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

import { getCalendarWithActiveProfileAddedToEvents } from 'flow/utils/calendar-utils';
import { sortProfilesAfterPlusId } from 'flow/utils/profile-utils';

const PbxLiveChatCalendar = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { entityKey } = useParams<{ entityKey: ChannelKey }>();

    const profiles = useAppSelector((state) =>
        state.channels.getIn(['channels', entityKey, 'profiles'], List()),
    );

    const calendar = useAppSelector((state) =>
        state.channels.getIn(['channels', entityKey, 'calendar']),
    );

    useEffect(() => {
        dispatch(fetchChannelCalendar(entityKey));
    }, []);

    if (!calendar || !profiles) {
        return <Loading />;
    }

    return (
        <CalendarBase
            calendar={getCalendarWithActiveProfileAddedToEvents(null, calendar)}
            entityKey={entityKey}
            profiles={sortProfilesAfterPlusId(profiles)}
            onClickBack={() =>
                history.push(
                    generatePath(routes['pbx.channels.entityKey.profiles'], {
                        entityKey,
                    }),
                )
            }
            updateOpeningHours={(openingHours) => {
                dispatch(updateChannelOpeningHours(entityKey, openingHours));
            }}
        />
    );
};

export default PbxLiveChatCalendar;
